

<script lang="ts">
// See https://class-component.vuejs.org/ for more details on class style components in Vue
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';

import { ClassDto } from "../models/PublicApi";
import { sortUserPlugins } from 'vite';

interface RowEventParams
{
    row: ClassDto,
    pageIndex: number,
    selected: boolean,
    event: MouseEvent
}

const ClassSearchResultsProps = Vue.extend({
    props: {
        isLoading: Boolean,
        searchResults: Array as PropType<Array<ClassDto>>
    }
})

@Component({
  components: {
    VueGoodTable
  }
})

export default class ClassSearch extends ClassSearchResultsProps {

    data() {
        return {
            columns: [
                {
                    label: 'Guaranteed\nTo Run',
                    field: 'guaranteedToRun',
                    width: '140px'
                },
                {
                    label: 'Date & Time',
                    field: 'time.formattedDate',
                    type: 'date',
                    // ex: August 10, 2021 09:00 AM
                    dateInputFormat: 'MMMM dd, yyyy hh:mm a',
                    dateOutputFormat: "MMMM dd, yyyy'<br>'hh:mm a",
                    width: '165px',
                    thClass: 'column-header'
                },
                {
                    label: 'Certification',
                    field: 'certification',
                    sortable: false,
                },
                {
                    label: 'Abbreviation',
                    field: 'certificationAbbreviation',
                    sortable: false,
                    width: '120px'
                },
               // {
                //    label: 'Class',
                  //  field: 'class',
                //},      
                {
                    label: 'Language',
                    field: 'language',
                    width: '140px'
                },       
                {
                    label: 'Location',
                    field: 'location',
                    width: '180px'
                },
                {
                    label: 'Training Provider',
                    field: 'provider',
                    width: '125px'
                }
            ],
            pagination:  {
                enabled: true,
                position: 'bottom',
                perPage: 25,
                perPageDropdownEnabled: false,
            },
        }
    }

    tableIsLoading: boolean = false;
    get showBusy(): boolean {
        return this.isLoading || this.tableIsLoading;
    }

    set showBusy(value: boolean) {
        this.tableIsLoading = value;
    }

    get rows(): Array<ClassDto> {
        if (this.searchResults) {
            return this.searchResults;
        }
        return [];
    }

    onRowClick(params: RowEventParams) {
        window.open('/class/' + params.row.id,
            '_blank');
    }

    onMouseEnter(params: RowEventParams) {
    }

    onMouseLeave(params: RowEventParams) {
    }

    getCertificationIconHtml(value: any) : string {
        return '';
    }

    mounted() {
    }
}
</script>
